import { themeAwardWidgetDecorator } from '../utils'
import { BowtieManagement } from './BowtieManagement'

export const BowtieManagementWrapper = themeAwardWidgetDecorator(BowtieManagement)
